import { PwaBridge } from '@/common/bridge';

export default function routerPlugin({ app, $isAppEnvironment = false }) {
    app.router.beforeEach((to, from, next) => {
        try {
            /**
             * @zh tiny 排除
             */
            const isTiny = /^\/tiny\/.*/.test(to.fullPath) || /^\/tiny\/.*/.test(from.fullPath);
            if (isTiny) {
                next();
                return;
            }

            if ($isAppEnvironment) {
                if (!from.name && from.fullPath === '/') {
                    next();
                    return;
                }
                PwaBridge.openWebview({
                    url: `${window?.location?.origin}${to?.fullPath || ''}`,
                });
                return;
            }
            next();
        } catch {
            next();
        }
    });
}
